import {
  CurrencyExchange,
  XCircleFill,
  ExclamationTriangleFill,
  ChatDotsFill,
  QuestionCircleFill,
} from 'react-bootstrap-icons';

const SECTIONS = [
  {
    icon: <XCircleFill />,
    title: 'All Sales Final',
    body: (
      <>
        <p>Money spent on the server is non-refundable. All donations are final — Paragon Conquer does not offer refunds or exchanges on any purchases made on the server.</p>
        <p>Please inspect all items carefully before purchasing them or adding Paragon Coins to your account.</p>
      </>
    ),
  },
  {
    icon: <ExclamationTriangleFill />,
    title: 'Chargeback Policy',
    body: (
      <>
        <div className="policy-alert">
          <span className="policy-alert-icon"><ExclamationTriangleFill /></span>
          <p>Disputing any payments or attempting to "charge back" will result in a permanent HWID ban on all associated accounts.</p>
        </div>
        <p>If you have a legitimate concern about a payment, contact us directly before initiating any dispute with your payment provider.</p>
      </>
    ),
  },
  {
    icon: <ChatDotsFill />,
    title: 'Payment Issues',
    body: (
      <p>If there are any issues with your payments, please contact us straight away through our website or Discord so we can quickly rectify your issue.</p>
    ),
  },
  {
    icon: <QuestionCircleFill />,
    title: 'Questions',
    body: (
      <p>If you have any questions or enquiries about our refund policy or any other information on our website, please contact us and we will reply promptly.</p>
    ),
  },
];

export function RefundPolicy() {
  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="policy-hero-icon"><CurrencyExchange /></div>
        <h2>Refund Policy</h2>
        <p>Please review our refund terms before making any purchases.</p>
      </div>

      {SECTIONS.map((s, i) => (
        <div key={i} className="policy-section">
          <div className="policy-section-header">
            <span className="policy-section-icon">{s.icon}</span>
            <h5>{s.title}</h5>
          </div>
          <div className="policy-section-body">{s.body}</div>
        </div>
      ))}

      <div className="policy-note">
        <p>By playing the server, you agree to the terms of service and this refund policy.</p>
      </div>
    </div>
  );
}
